module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_1.c15880c6.png";